import { Injectable } from "@angular/core";
import { FrameContext, NgFormControl } from "@farris/devkit";

@Injectable()
export class FormControlService {
  constructor() { }
  public getFormControlsByFrameContext(frameContext: FrameContext): { [propertyName: string]: NgFormControl } | null {
    return frameContext && frameContext.form && frameContext.form.ngFormControls || null;
  }
  /**
   * éè¿bindingåæ°æ®è·åNgFormControl
   * @param frameContext 
   * @param binding binding
   * @returns 
   */
  public getFormControlByBinding(frameContext: FrameContext, binding: string): NgFormControl {
    const ngFormControls = this.getFormControlsByFrameContext(frameContext);
    if (!ngFormControls) {
      return null;
    }
    return Object.values(ngFormControls).find((ngFormControl: NgFormControl) => ngFormControl && ngFormControl.binding === binding);

  }
  /**
   * 
   * @param frameContext frameContext
   * @param fullPath 
   * @returns 
   */
  public getFormControlIndexByFullPath(frameContext: FrameContext, fullPath: string): number {
    const ngFormControls = this.getFormControlsByFrameContext(frameContext);
    if (!ngFormControls) {
      return null;
    }
    const bindings = fullPath.split('/').filter(p => p);
    return Object.values(ngFormControls).findIndex((ngFormControl: NgFormControl) => {
      if (!ngFormControl) {
        return false;
      }
      const bindingPath = frameContext.viewModel.bindingPath;
      const bindingPaths = bindingPath.split('/').filter(p => p);
      const formControlBindingPaths = ngFormControl.binding.split('.').filter(p => p);
      const fullPath = bindingPaths.concat(formControlBindingPaths);
      return fullPath.join('/') === bindings.join('/');
    });
  }
  /**
   * éè¿bindingåæ°æ®è·åNgFormControlä½ç½®
   * @param frameContext 
   * @param binding binding
   * @returns ä»0å¼å§
   */
  public getFormControlIndexByBinding(frameContext: FrameContext, binding: string): number {
    const ngFormControls = this.getFormControlsByFrameContext(frameContext);
    if (!ngFormControls) {
      return null;
    }
    return Object.values(ngFormControls).findIndex((ngFormControl: NgFormControl) => ngFormControl && ngFormControl.binding === binding);
  }
}